import axios from "axios";
import { API_URL } from "../constants";
import { CrmProjectLinkSummary } from "../types/Desk";

export type { CrmProjectLinkSummary };

export async function searchCrmProjects(
  companyId: string,
  q: string,
  limit = 20
): Promise<{ entries: CrmProjectLinkSummary[] }> {
  const res = await axios.get(`${API_URL}/${companyId}/projects/search`, {
    params: { q, limit },
  });
  return res.data;
}
